import { Routes } from "@angular/router";
import { DirtyGuard } from "~app/common/guards/dirty.guard";
import { RaskRoller } from "~app/common/models/constants";
import { CanEditResolver } from "~app/common/resolvers/can-edit.resolver";
import { JusteraLeveransplanComponent } from "../features/justera-leveransplan/justera-leveransplan.component";

export const leveransplanRoutes: Routes = [
    {
        path: "justeraleveransplan",
        redirectTo: "justeraleveransplan/",
        pathMatch: "full"
    },
    {
        path: "justeraleveransplan/:tab",
        title: "Justera leveransplan",
        component: JusteraLeveransplanComponent,
        canDeactivate: [DirtyGuard],
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Kundhantera]
        },
        resolve: {
            canEdit: CanEditResolver
        }
    }
];
